import {APIPlatformSerializer} from './abstract';

export class CurrencySerializer extends APIPlatformSerializer {
  base = '/currencies';
}
